import { QuoteBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/quoteBlock/quoteBlock.layout'
import { onlyNumbers } from '@shared/Frontend/utils/numbers'
import * as React from 'react'
import { Updater, IOWidget, fromJSX,  } from 'widgets-for-react'
import { CMSState, Id, ImageSize, Link } from '../types.gen'

export type QuoteBlockProps = {
  index: number
  text: string
  author?: string
  link?: Link | null
  image?: Id
  image_alt?: string
  image_size?: ImageSize
  get_default_data_src: () => ImageSize
  get_default_data_srcset: () => [ImageSize, string][]
}

export function QuoteBlock(
  props: QuoteBlockProps
): IOWidget<CMSState, Updater<CMSState>> {
  return (cmsState: CMSState) =>
    fromJSX(() => {
        const imageSrc = () => {
          const image = cmsState.images.get(props.image)
          // We know this is always loaded, see `image_utils.mod.ts`
          if (image.kind != 'loaded') {
            throw new Error(
              `Image with id ${image} is not loaded yet. Ensure that the image is loaded before accessing its value.`
            )
          }
          return image.value
        }

        return (
          <>
            <QuoteBlockLayout
              id="example-quote-block"
              text={props.text}
              author={props.author}
              image={
                props.image
                  ? {
                      alt: props.image_alt,
                      src: imageSrc().get(props.get_default_data_src()),
                      crops: props.get_default_data_srcset().map(([ url, width ]) => ({
                        url: imageSrc().get(url),
                        width: Number(onlyNumbers(width))
                      }))
                    }
                  : undefined
              }
              primaryUpdater={
                props.link
                  ? {
                      ...props.link,
                      isExternal: props.link.is_link_external
                    }
                  : undefined
              }
            />
          </>
        )
      }
    )
}
